/* eslint-disable react/no-danger -- Rich text is sanitized with DOMPurify before rendering. */
import React from 'react';
import DOMPurify from 'dompurify';
import { HexToRGB } from '@/utils/utils';

const RichTextBlockProd = props => {
  const {
    // visible,
    topMargin,
    horizontalOutterMargin,
    bottomMargin,
    horizontalInnerPadding,
    topPadding,
    bottomPadding,
    hasBg,
    bgColor,
    bgColorOpacity,
    htmlContent,
    cardCorner,
    bgImg,
    bgType,
  } = props || {};
  // 构建背景样式
  const bgStyle = {
    marginTop: `${topMargin / 100}rem`,
    marginBottom: `${bottomMargin / 100}rem`,
    marginLeft: `${(Number(horizontalOutterMargin || 0) - 12) / 100}rem`,
    marginRight: `${(Number(horizontalOutterMargin || 0) - 12) / 100}rem`,
    backgroundSize: '100%',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      hasBg === 'Y' && bgType === 'Color' ? HexToRGB(bgColor, bgColorOpacity) : 'transparent',
    borderRadius: `${cardCorner}px`,
    backgroundImage:
      hasBg === 'Y' && bgType === 'Image' && bgImg?.src ? `url(${bgImg.src})` : 'none',
  };

  const innerStyle = {
    paddingTop: `${topPadding / 100}rem`,
    paddingBottom: `${bottomPadding / 100}rem`,
    paddingLeft: `${horizontalInnerPadding / 100}rem`,
    paddingRight: `${horizontalInnerPadding / 100}rem`,
  };

  return (
    <div style={bgStyle}>
      <div style={innerStyle}>
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlContent || '') }} />
      </div>
    </div>
  );
};

export default RichTextBlockProd;
